export const optionsDentalCouncilName: any = [
  {
    value: 'Andhra Pradesh State Dental Council',
    label: 'Andhra Pradesh State Dental Council',
  },
  {
    value: 'Arunachal Pradesh State Dental Council',
    label: 'Arunachal Pradesh State Dental Council',
  },
  {value: 'Assam State Dental Council', label: 'Assam State Dental Council'},
  {value: 'Bihar State Dental Council', label: 'Bihar State Dental Council'},
  {
    value: 'Chhatisgarh State Dental Council',
    label: 'Chhatisgarh State Dental Council',
  },
  {value: 'Delhi State Dental Council', label: 'Delhi State Dental Council'},
  {
    value: 'Dental Council of Chandigarh',
    label: 'Dental Council of Chandigarh',
  },
  {value: 'Goa State Dental Council', label: 'Goa State Dental Council'},
  {
    value: 'Gujarat State Dental Council',
    label: 'Gujarat State Dental Council',
  },
  {
    value: 'Haryana State Dental Council',
    label: 'Haryana State Dental Council',
  },
  {
    value: 'Himachal Pradesh State Dental Council',
    label: 'Himachal Pradesh State Dental Council',
  },
  {value: 'J & K State Dental Council', label: 'J & K State Dental Council'},
  {
    value: 'Jharkhand State Dental Council',
    label: 'Jharkhand State Dental Council',
  },
  {
    value: 'Karnataka State Dental Council',
    label: 'Karnataka State Dental Council',
  },
  {
    value: 'Kerala State Dental Council',
    label: 'Kerala State Dental Council',
  },
  {
    value: 'Madhya Pradesh State Dental Council',
    label: 'Madhya Pradesh State Dental Council',
  },
  {
    value: 'Maharashtra State Dental Council',
    label: 'Maharashtra State Dental Council',
  },
  {
    value: 'Manipur State Dental Council',
    label: 'Manipur State Dental Council',
  },
  {
    value: 'Meghalaya State Dental Council',
    label: 'Meghalaya State Dental Council',
  },
  {
    value: 'Nagaland State Dental Council',
    label: 'Nagaland State Dental Council',
  },
  {
    value: 'Orissa State Dental Council',
    label: 'Orissa State Dental Council',
  },
  {
    value: 'Punjab State Dental Council',
    label: 'Punjab State Dental Council',
  },
  {
    value: 'Rajasthan State Dental Council',
    label: 'Rajasthan State Dental Council',
  },
  {
    value: 'Sikkim Dental Registration Tribunal',
    label: 'Sikkim Dental Registration Tribunal',
  },
  {
    value: 'State Dental Council, Puducherry',
    label: 'State Dental Council, Puducherry',
  },
  {
    value: 'Tamil Nadu State Dental Council',
    label: 'Tamil Nadu State Dental Council',
  },
  {
    value: 'Telangana State Dental Council',
    label: 'Telangana State Dental Council',
  },
  {
    value: 'Tripura State Dental Council',
    label: 'Tripura State Dental Council',
  },
  {
    value: 'Uttar Pradesh State Dental Council',
    label: 'Uttar Pradesh State Dental Council',
  },
  {
    value: 'Uttarakhand Dentists Registration Tribunals',
    label: 'Uttarakhand Dentists Registration Tribunals',
  },
  {
    value: 'West Bengal State Dental Council',
    label: 'West Bengal State Dental Council',
  },
]

export const totalAlignersList: any = [
  {value: 1, label: '1'},
  {value: 2, label: '2'},
  {value: 3, label: '3'},
  {value: 4, label: '4'},
  {value: 5, label: '5'},
  {value: 6, label: '6'},
  {value: 7, label: '7'},
  {value: 8, label: '8'},
  {value: 9, label: '9'},
  {value: 10, label: '10'},
  {value: 11, label: '11'},
  {value: 12, label: '12'},
  {value: 13, label: '13'},
  {value: 14, label: '14'},
  {value: 15, label: '15'},
  {value: 16, label: '16'},
  {value: 17, label: '17'},
  {value: 18, label: '18'},
  {value: 19, label: '19'},
  {value: 20, label: '20'},
  {value: 21, label: '21'},
  {value: 22, label: '22'},
  {value: 23, label: '23'},
  {value: 24, label: '24'},
  {value: 25, label: '25'},
  {value: 26, label: '26'},
  {value: 27, label: '27'},
  {value: 28, label: '28'},
  {value: 29, label: '29'},
  {value: 30, label: '30'},
  {value: 31, label: '31'},
  {value: 32, label: '32'},
  {value: 33, label: '33'},
  {value: 34, label: '34'},
  {value: 35, label: '35'},
  {value: 36, label: '36'},
  {value: 37, label: '37'},
  {value: 38, label: '38'},
  {value: 39, label: '39'},
  {value: 40, label: '40'},
  {value: 41, label: '41'},
  {value: 42, label: '42'},
  {value: 43, label: '43'},
  {value: 44, label: '44'},
  {value: 45, label: '45'},
  {value: 46, label: '46'},
  {value: 47, label: '47'},
  {value: 48, label: '48'},
  {value: 49, label: '49'},
  {value: 50, label: '50'},
  {value: 51, label: '51'},
  {value: 52, label: '52'},
  {value: 53, label: '53'},
  {value: 54, label: '54'},
  {value: 55, label: '55'},
  {value: 56, label: '56'},
  {value: 57, label: '57'},
  {value: 58, label: '58'},
  {value: 59, label: '59'},
  {value: 60, label: '60'},
  {value: 61, label: '61'},
  {value: 62, label: '62'},
  {value: 63, label: '63'},
  {value: 64, label: '64'},
  {value: 65, label: '65'},
  {value: 66, label: '66'},
  {value: 67, label: '67'},
  {value: 68, label: '68'},
  {value: 69, label: '69'},
  {value: 70, label: '70'},
  {value: 71, label: '71'},
  {value: 72, label: '72'},
  {value: 73, label: '73'},
  {value: 74, label: '74'},
  {value: 75, label: '75'},
  {value: 76, label: '76'},
  {value: 77, label: '77'},
  {value: 78, label: '78'},
  {value: 79, label: '79'},
  {value: 80, label: '80'},
  {value: 81, label: '81'},
  {value: 82, label: '82'},
  {value: 83, label: '83'},
  {value: 84, label: '84'},
  {value: 85, label: '85'},
  {value: 86, label: '86'},
  {value: 87, label: '87'},
  {value: 88, label: '88'},
  {value: 89, label: '89'},
  {value: 90, label: '90'},
  {value: 91, label: '91'},
  {value: 92, label: '92'},
  {value: 93, label: '93'},
  {value: 94, label: '94'},
  {value: 95, label: '95'},
  {value: 96, label: '96'},
  {value: 97, label: '97'},
  {value: 98, label: '98'},
  {value: 99, label: '99'},
  {value: 100, label: '100'},
]

export const wearDaysList: any = [
  // {value: 1,label: "1 Day"},
  {value: 2, label: '2 Days'},
  {value: 3, label: '3 Days'},
  {value: 4, label: '4 Days'},
  {value: 5, label: '5 Days'},
  {value: 6, label: '6 Days'},
  {value: 7, label: '7 Days'},
  {value: 8, label: '8 Days'},
  {value: 9, label: '9 Days'},
  {value: 10, label: '10 Days'},
  {value: 11, label: '11 Days'},
  {value: 12, label: '12 Days'},
  {value: 13, label: '13 Days'},
  {value: 14, label: '14 Days'},
  {value: 15, label: '15 Days'},
  {value: 16, label: '16 Days'},
  {value: 17, label: '17 Days'},
  {value: 18, label: '18 Days'},
  {value: 19, label: '19 Days'},
  {value: 20, label: '20 Days'},
  {value: 21, label: '21 Days'},
  {value: 22, label: '22 Days'},
  {value: 23, label: '23 Days'},
  {value: 24, label: '24 Days'},
  {value: 25, label: '25 Days'},
  {value: 26, label: '26 Days'},
  {value: 27, label: '27 Days'},
  {value: 28, label: '28 Days'},
  {value: 29, label: '29 Days'},
  {value: 30, label: '30 Days'},
  {value: 31, label: '31 Days'},
  {value: 32, label: '32 Days'},
  {value: 33, label: '33 Days'},
  {value: 34, label: '34 Days'},
  {value: 35, label: '35 Days'},
  {value: 36, label: '36 Days'},
  {value: 37, label: '37 Days'},
  {value: 38, label: '38 Days'},
  {value: 39, label: '39 Days'},
  {value: 40, label: '40 Days'},
  {value: 41, label: '41 Days'},
  {value: 42, label: '42 Days'},
  {value: 43, label: '43 Days'},
  {value: 44, label: '44 Days'},
  {value: 45, label: '45 Days'},
  {value: 46, label: '46 Days'},
  {value: 47, label: '47 Days'},
  {value: 48, label: '48 Days'},
  {value: 49, label: '49 Days'},
  {value: 50, label: '50 Days'},
  {value: 51, label: '51 Days'},
  {value: 52, label: '52 Days'},
  {value: 53, label: '53 Days'},
  {value: 54, label: '54 Days'},
  {value: 55, label: '55 Days'},
  {value: 56, label: '56 Days'},
  {value: 57, label: '57 Days'},
  {value: 58, label: '58 Days'},
  {value: 59, label: '59 Days'},
  {value: 60, label: '60 Days'},
  {value: 61, label: '61 Days'},
  {value: 62, label: '62 Days'},
  {value: 63, label: '63 Days'},
  {value: 64, label: '64 Days'},
  {value: 65, label: '65 Days'},
  {value: 66, label: '66 Days'},
  {value: 67, label: '67 Days'},
  {value: 68, label: '68 Days'},
  {value: 69, label: '69 Days'},
  {value: 70, label: '70 Days'},
  {value: 71, label: '71 Days'},
  {value: 72, label: '72 Days'},
  {value: 73, label: '73 Days'},
  {value: 74, label: '74 Days'},
  {value: 75, label: '75 Days'},
  {value: 76, label: '76 Days'},
  {value: 77, label: '77 Days'},
  {value: 78, label: '78 Days'},
  {value: 79, label: '79 Days'},
  {value: 80, label: '80 Days'},
  {value: 81, label: '81 Days'},
  {value: 82, label: '82 Days'},
  {value: 83, label: '83 Days'},
  {value: 84, label: '84 Days'},
  {value: 85, label: '85 Days'},
  {value: 86, label: '86 Days'},
  {value: 87, label: '87 Days'},
  {value: 88, label: '88 Days'},
  {value: 89, label: '89 Days'},
  {value: 90, label: '90 Days'},
  {value: 91, label: '91 Days'},
  {value: 92, label: '92 Days'},
  {value: 93, label: '93 Days'},
  {value: 94, label: '94 Days'},
  {value: 95, label: '95 Days'},
  {value: 96, label: '96 Days'},
  {value: 97, label: '97 Days'},
  {value: 98, label: '98 Days'},
  {value: 99, label: '99 Days'},
  {value: 100, label: '100 Days'},
]

export const dailyWearHoursList: any = [
  {value: 24, label: '24 Hours'},
  {value: 23, label: '23 Hours'},
  {value: 22, label: '22 Hours'},
  {value: 21, label: '21 Hours'},
  {value: 20, label: '20 Hours'},
  {value: 19, label: '19 Hours'},
  {value: 18, label: '18 Hours'},
  {value: 17, label: '17 Hours'},
  {value: 16, label: '16 Hours'},
  {value: 15, label: '15 Hours'},
  {value: 14, label: '14 Hours'},
  {value: 13, label: '13 Hours'},
  {value: 12, label: '12 Hours'},
  {value: 11, label: '11 Hours'},
  {value: 10, label: '10 Hours'},
  {value: 9, label: '9 Hours'},
  {value: 8, label: '8 Hours'},
  {value: 7, label: '7 Hours'},
  {value: 6, label: '6 Hours'},
  {value: 5, label: '5 Hours'},
  {value: 4, label: '4 Hours'},
  {value: 3, label: '3 Hours'},
  {value: 2, label: '2 Hours'},
  {value: 1, label: '1 Hour'},
]
